import React from 'react';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedInOutlined';
import TextWithIcon from '../../../../../components/Input/TextWithIcon';

export default ({actualsApprovedBy}) => {
    return (<div style={{position: 'relative'}}>
            <TextWithIcon label="Actuals approved by" value={actualsApprovedBy} icon={AssignmentTurnedIn}/>
        </div>)
}